import { render, staticRenderFns } from "./Xsjl.vue?vue&type=template&id=4500e1d3&scoped=true"
import script from "./Xsjl.vue?vue&type=script&lang=js"
export * from "./Xsjl.vue?vue&type=script&lang=js"
import style0 from "./Xsjl.vue?vue&type=style&index=0&id=4500e1d3&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500e1d3",
  null
  
)

export default component.exports